import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";

const useDeletePotential = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const deletePotential = async (potential) => {
        if (!potential) {
            toast.error("Deal not found.");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "deletePotential",
                potential,
            });
            toast.success("Deal deleted.");
            return response;
        } catch (err) {
            toast.error(err.response.data.text);
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, deletePotential };
};

export default useDeletePotential;
